import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import Icon from '../icon';
const styles = {
  default: {
    color: Colors.gray500,
    weight: 'regular'
  },
  expanded: {
    color: Colors.advanceBlue400,
    weight: 'bold'
  }
};
const StyledContainer = styled.View`
  flex-direction: column;
  width: 100%;
`;
const StyledPressable = styled.Pressable`
  flex-direction: row;
  align-self: flex-start;
  justify-content: space-between;
  width: 100%;
`;
const StyledItemContainer = styled.View`
  flex-direction: column;
  width: 100%;
  padding: 16px;
`;
const StyledItem = styled(Text.BodySmall)`
  line-height: 16.8px;
`;
export default function NavigationListItem(props) {
  const [expanded, setExpanded] = useState(false);
  const hasItems = props.items.length > 0;
  const style = expanded ? styles.expanded : styles.default;

  const expandItem = () => setExpanded(!expanded);

  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(StyledPressable, {
    onPress: hasItems ? expandItem : props.onPress
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: style.weight,
    color: style.color
  }, props.children), hasItems && /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: expanded ? 'expand-less' : 'expand-more',
    size: 20,
    color: Colors.gray500
  })), expanded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(StyledItemContainer, null, props.items.map((item, index) => {
    const isLast = index === props.items.length - 1;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(StyledItem, {
      weight: "medium",
      color: Colors.gray300,
      onPress: item.onPress
    }, item.label), !isLast && /*#__PURE__*/React.createElement(Spacer, {
      size: "f16",
      height: true
    }));
  }))));
}
const itemShape = {
  label: PropTypes.string,
  onPress: PropTypes.func
};
NavigationListItem.propTypes = {
  children: PropTypes.string,
  onPress: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape(itemShape))
};
NavigationListItem.defaultProps = {
  children: '',
  onPress: () => {},
  items: []
};
//# sourceMappingURL=index.js.map